import React from "react";
import "./EndingFooter.css";
import ByPolko from "../ByPolko";
import WhatsAppFAB from "../ProductsCustomer/WhatsAppFAB";
import phone_pink from "../../../assets/images/phone_pink.png";

const EndingFooter = () => {
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "95%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <h2
            className="font-face-encode-sans-bold pink-font"
            style={{ fontSize: "35px", maxWidth: "500px" }}
          >
            A LA BREVEDAD UN ASESOR SE CONTACTARÁ CON USTED
          </h2>
        </div>
        

        <div
          className="decoration-phones-container"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "40%",
            marginTop:"-3%",
            marginLeft:"8%",
            alignSelf: "self-start",
          }}
        > 
        
        <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <img
              style={{ transform: "rotate(20deg)"}}
              src={phone_pink}
              alt="phone_pink"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <img
              style={{ transform: "rotate(-10deg) scale(0.75,0.75)" }}
              src={phone_pink}
              alt="phone_pink"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <img
              style={{ transform: "rotate(40deg) scale(0.9,0.9)" }}
              src={phone_pink}
              alt="phone_pink"
            />
          </div>
        
        
        </div>
        <div
          className="decoration-phones-container"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "30%",
            marginTop:"-3%",
            alignSelf: "self-end",
          }}
        > 
        
        <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
 
            <img
              style={{ transform: "rotate(40deg) scale(0.75,0.75)" }}
              src={phone_pink}
              alt="phone_pink"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent:"self-end"
            }}
          >

            <img
              style={{ transform: "rotate(120deg) scale(1.1,1.1)" }}
              src={phone_pink}
              alt="phone_pink"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
 
            <img
              style={{ transform: "rotate(-10deg)" }}
              src={phone_pink}
              alt="phone_pink"
            />
          </div>
        
        </div>
          

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "right",
              zIndex:"1000"
          }}
        >
          {/*<ByPolko fontSize={24}/>*/}
          <WhatsAppFAB/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EndingFooter;
